import React, { useEffect } from "react";
import Title from "../components/TitleChanger";
import { IconCode } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getUserWorkflows,
  getWorkflowLoading,
  getWorkflowError,
  fetchUserWorkflows,
  removeWorkflow,
} from "../slices/workflowSlice";
import { useAppDispatch } from "../store";

export default function WorkflowsView() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const workflows = useSelector(getUserWorkflows);
  const loading = useSelector(getWorkflowLoading);
  const error = useSelector(getWorkflowError);

  useEffect(() => {
    dispatch(fetchUserWorkflows());
  }, [dispatch]);

  const handleDelete = (id: number) => {
    if (window.confirm("Are you sure you want to delete this workflow?")) {
      dispatch(removeWorkflow(id));
    }
  };

  const handleEdit = (id: number) => {
    navigate(`/app/workflows/edit/${id}`);
  };

  return (
    <div className="page">
      <Title pageTitle={"Workflows | "} />
      <div className="container">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <h1 className="display-6" style={{ fontWeight: "700" }}>
              <IconCode style={{ paddingBottom: "5px" }} size={36} />
              Your Workflows
            </h1>
            <hr />
            {loading && <div>Loading workflows...</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            {!loading && !error && (
              <div>
                {workflows.length === 0 ? (
                  <div>No workflows found.</div>
                ) : (
                  <ul className="list-group">
                    {workflows.map((wf) => (
                      <li
                        key={wf.id}
                        className="list-group-item"
                        style={{
                          borderRadius: "16px",
                          marginBottom: "24px",
                          //   boxShadow: "0 1px 8px 0 rgba(60,60,120,0.08)",
                          border: "1px solid #eee",
                          padding: "24px 32px",
                          display: "flex",
                          alignItems: "center",
                          minHeight: 100,
                        }}
                      >
                        {/* Icon + color */}
                        <div
                          style={{
                            minWidth: 64,
                            minHeight: 64,
                            width: 96,
                            height: 96,
                            background: wf.background || "#eaeaea",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 24,
                            border: "1px solid #eaeaea",
                            overflow: "hidden",
                          }}
                        >
                          {wf.icon ? (
                            <span
                              style={{ color: wf.color || "#bbb" }}
                              dangerouslySetInnerHTML={{ __html: wf.icon }}
                            />
                          ) : (
                            <span style={{ color: "#bbb", fontSize: 32 }}>
                              ?
                            </span>
                          )}
                        </div>

                        {/* Main content */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 12,
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                fontWeight: 700,
                                wordBreak: "break-all",
                              }}
                            >
                              {wf.title}
                            </h4>
                            {wf.category && (
                              <span
                                style={{
                                  marginLeft: 8,
                                  padding: "2px 12px",
                                  background: "#f1f3fa",
                                  color: "#606078",
                                  borderRadius: "20px",
                                  fontSize: "0.95em",
                                  fontWeight: 500,
                                }}
                              >
                                {wf.category}
                              </span>
                            )}
                          </div>
                          <div style={{ margin: "8px 0 16px", color: "#333" }}>
                            {wf.description}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: 12,
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <span
                              className="badge bg-secondary"
                              style={{ fontWeight: 600 }}
                            >
                              Views: {wf.views}
                            </span>
                            {wf.approved ? (
                              <span
                                className="badge bg-success"
                                style={{ fontWeight: 600 }}
                              >
                                Approved
                              </span>
                            ) : (
                              <span
                                className="badge bg-warning"
                                style={{ fontWeight: 600 }}
                              >
                                Pending
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Action buttons */}
                        <div
                          style={{
                            marginLeft: 32,
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                          }}
                        >
                          <button
                            className="btn btn-sm btn-outline-primary"
                            style={{ minWidth: 82 }}
                            onClick={() => handleEdit(wf.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            style={{ minWidth: 82 }}
                            onClick={() => handleDelete(wf.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
